import React from 'react'
import { FetchUserPlaylistsPlaylistTypeEnum as playlistTypeEnum } from '@swagger'
import PlaylistGrid from '@components/Playlist/PlaylistGrid'

const PlaylistTabLC: React.FC = () => {
  return (
    <PlaylistGrid
      playlistType={playlistTypeEnum.LearningCenter}
      basePath="learning"
    />
  )
}

export default PlaylistTabLC
